import type { MtoMaterialPosition } from '@entities/mto';
import { fmtNum, needsCheck, positionRaw } from '@entities/mto';
import {
  Name,
  Small,
  Source,
  Table,
  TableScroll,
  Tr,
} from '../styles';
import { MultNote } from './MultNote';
import { ReviewReasons } from './ReviewReasons';
import { RowDecision } from './RowDecision';

export function RebarTable({
  rows,
  shown,
  runId,
  canWrite,
  onRowError,
}: {
  rows: MtoMaterialPosition[];
  shown: number;
  runId: string;
  canWrite: boolean;
  onRowError: (msg: string) => void;
}) {
  return (
    <TableScroll tabIndex={0} role="region" aria-label="Свод арматуры">
      <Table>
        <thead>
          <tr>
            <th scope="col">Класс арматуры</th>
            <th scope="col" className="num">
              Ø, мм
            </th>
            <th scope="col" className="num">
              Кол-во, шт
            </th>
            <th scope="col" className="num">
              Длина, м
            </th>
            <th scope="col" className="num">
              Масса, т
            </th>
            <th scope="col">Проверка</th>
          </tr>
        </thead>
        <tbody>
          {rows.slice(0, shown).map((p) => {
            const r = positionRaw(p);
            const excluded = p.decision === 'rejected';
            return (
              <Tr key={p.id} $review={needsCheck(p)}>
                <td>
                  <Name $excluded={excluded}>{r.rebar_class ?? p.name}</Name>
                  {r.per_unit && <Small>на 1 элемент — в «Итого арматуры» не входит</Small>}
                  <Source title={p.source_ref}>{p.source_ref}</Source>
                  <ReviewReasons reasons={needsCheck(p) ? (r.review_reasons ?? []) : []} />
                </td>
                <td className="num">{r.diameter_mm ?? '—'}</td>
                <td className="num">{fmtNum(r.count_pcs)}</td>
                <td className="num">{fmtNum(r.length_m)}</td>
                <td className="num">
                  {r.mass_kg != null ? fmtNum(r.mass_kg / 1000) : '—'}
                  {r.mass_kg != null && <Small>{fmtNum(r.mass_kg)} кг</Small>}
                  <MultNote
                    m={r.multiplicity}
                    manual={r.multiplicity_manual}
                    total={
                      r.mass_mult_kg != null ? `${fmtNum(r.mass_mult_kg / 1000)} т` : null
                    }
                  />
                </td>
                <td>
                  <RowDecision
                    position={p}
                    runId={runId}
                    canWrite={canWrite}
                    onError={onRowError}
                  />
                </td>
              </Tr>
            );
          })}
        </tbody>
      </Table>
    </TableScroll>
  );
}
